import { motion, useReducedMotion } from "framer-motion";

const BLOCKS = [
  {
    title: "One call does it all",
    text: "Glass, repairs and gardens handled by the same local operator. No juggling tradies, no chasing callbacks.",
    testid: "why-block-one-call",
  },
  {
    title: "No job too small",
    text: "A single cracked pane or a full garden tidy-up \u2014 if it's on your list, it's on ours.",
    testid: "why-block-no-job-small",
  },
  {
    title: "Straight-up pricing",
    text: "A clear quote before we start. No surprises, no jargon, no fluff.",
    testid: "why-block-pricing",
  },
];

const EASE = [0.16, 1, 0.3, 1];

export const WhyUs = () => {
  const reduce = useReducedMotion();

  return (
    <section data-testid="why-us-section" className="bg-sand py-20 md:py-28">
      <div className="safe-x mx-auto max-w-7xl">
        <motion.div
          initial={reduce ? false : { opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
        >
          <p className="eyebrow">Why choose us</p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] text-navy sm:text-5xl lg:text-6xl">
            No fuss. <span className="text-outline-orange">Just fixed.</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8">
          {BLOCKS.map((block, i) => (
            <motion.div
              key={block.title}
              data-testid={block.testid}
              initial={reduce ? false : { opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: EASE, delay: i * 0.12 }}
              className="border-t-4 border-orange pt-7"
            >
              <h3 className="font-display text-2xl font-semibold uppercase tracking-wide text-navy">
                {block.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-navy/70 md:text-base">{block.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
